<div class="print-footer-tile">
  <div class="footer-content">
    @if (dateInst.dtp) {
      <div>Created by {{appScope.current_user.name}} on {{currentDate()  | stringDate}}
      </div>
    }
    <div class="right">Page {{config?.current_page || 1}}</div>
    <!--  <div class="right">Powered by MMS WIRE. https://www.metalmanagementsolutions.com</div>-->
  </div>
</div>
